import { FC } from "react";
import { useContactContext } from "../../contexts/ContactContext";
import { ArrowRightCircleIcon } from "@heroicons/react/24/outline";
import {
  ArrowTopRightOnSquareIcon,
  ChatBubbleLeftRightIcon,
  QuestionMarkCircleIcon
} from "@heroicons/react/20/solid";
import { UnderdotsLogo } from "../logos/underdots/UnderdotsLogo";

export const JobEstimate: FC<{
  sections: string[];
  openLinkInNewWindow: boolean;
}> = ({ sections, openLinkInNewWindow }) => {
  const { openContactModal } = useContactContext();
  return (
    <div className="w-full h-fit px-6 py-4 flex justify-between flex-col bg-gray-900 mb-3 rounded-lg">
      <div className="flex justify-start">
        <UnderdotsLogo className="h-4" wordFill="#a6e200" />
      </div>
      <h1 className="text-2xl reveal-font-title text-white mb-1">
        Job Estimate
      </h1>
      <p className="reveal-font-body text-sm text-gray-200 ">
        To provide an accurate estimate, we need the following information:
      </p>
      <div className="flex flex-col gap-2 mt-4 mb-10 ">
        {sections.map((section) => (
          <div className="flex gap-2 items-center" key={section}>
            <ArrowRightCircleIcon className="h-5 w-5 text-underdotsGreen-500" />
            <p className="text-white reveal-font-body text-sm">{section}</p>
          </div>
        ))}
      </div>
      <div className="flex py-2 flex-col items-start border-t border-t-gray-600">
        <p className="text-gray-300 reveal-font-title text-sm mb-2">
          Need help?
        </p>
        <div className="flex gap-2 items-center reveal-font-body text-sm mb-2">
          <QuestionMarkCircleIcon className="h-5 w-5 fill-gray-400" />

          <a
            className="text-underdotsGreen-500 underline underline-offset-4 flex items-center gap-2"
            href="https://reveal.nz/underdots"
            {...(openLinkInNewWindow
              ? { target: "_blank", rel: "noreferrer" }
              : {})}
          >
            Read Underdots FAQs
            <ArrowTopRightOnSquareIcon className="h-4 w-4 fill-underdotsGreen-500" />
          </a>
        </div>
        <div className="flex gap-2 items-center reveal-font-body text-sm">
          <ChatBubbleLeftRightIcon className="h-5 w-5 fill-gray-400" />
          <button
            className="text-underdotsGreen-500 underline underline-offset-4"
            onClick={() => openContactModal()}
          >
            Get in touch
          </button>
        </div>
      </div>
    </div>
  );
};
